import React,{useContext,useState} from 'react'
import Input from '../../components/Input/index.js'
import Textarea from '../../components/Textarea/index.js'
import {Row,Col,Container,Alert} from 'react-bootstrap'
import {FaUserAlt} from 'react-icons/fa'
import {HiMail} from 'react-icons/hi'
import {AiFillPhone,AiFillMessage} from 'react-icons/ai'
import axios from 'axios'
import PrefixContext from "../../context/PrefixContext.js";
import PrivacyTnc from '../../components/PrivacyTnc/index.js'

function Index() {

    const PrefixContextData = useContext(PrefixContext);
    const defaultValidation = {
        validationStatus: null,
        validationStatusClass: null,
        validationStatusMessage: null,
        name:[],
        email:[],
        phone:[],
        message:[]
    }
    const [validation,setValidation] = useState(defaultValidation);
    const [data, setdata] = useState({
        name:"",
        email:"",
        phone:"",
        message:""
    })

    const submitEnquiry = async (e) => {
        e.preventDefault();
        if (validation.validationStatusClass === 'warning') return;
        setValidation({
            validationStatus: true,
            validationStatusClass:'warning',
            validationStatusMessage: 'Please wait sending message ...',
            name:null,
            email:null,
            phone:null,
            message:null
        });
        await axios.post(PrefixContextData.prefixUrl + 'contact', data)
        .then(response => {
            if(response.status === 200){
                setValidation({
                    validationStatus: true,
                    validationStatusClass:'success',
                    validationStatusMessage: response.data.successMessage,
                    name:null,
                    email:null,
                    phone:null,
                    message:null
                });
            }
        })
        .catch(error => {
            if(error.response !== undefined && error.response.data !== undefined && error.response.data.errorMessageDetails !== undefined ){
                let errorDetails = {};
                error.response.data.errorMessageDetails.forEach((e)=>{
                    errorDetails[e.param] = e.msg;
                })
                setValidation({
                    validationStatus: true,
                    validationStatusClass:'danger',
                    validationStatusMessage: error.response.data.errorMessage,
                    name:(errorDetails.name !== undefined) ? errorDetails.name : null,
                    email:(errorDetails.email !== undefined) ? errorDetails.email : null,
                    phone:(errorDetails.phone !== undefined) ? errorDetails.phone : null,
                    message:(errorDetails.message !== undefined) ? errorDetails.message : null
                });
            }
        });
    }

    const onChangeHandler = (e) =>{
        const newData = {
            ...data
        }
        newData[e.target.name]=e.target.value;
        setdata(newData);
    }

    return (
        <>
        <div className="new-section page-heading-margin d-flex">
            <Container className="my-auto">
                <Row className="mt-3 mt-md-3">
                    <Col md={{size:"6",order:2}} className="mb-5 mb-md-0">
                        <div className="form px-md-5">
                        <h4>Get in touch</h4>
                        <p>Give us a feedback on the product or send some suggestions we will try to implement it.</p>
                        {validation.validationStatus === true && <Alert className="mb-0" variant={validation.validationStatusClass}>
                            {validation.validationStatusMessage}
                        </Alert>}
                        <form className="contactForm" onSubmit={submitEnquiry}>
                            <Input type="text" name="name" onChangeHandler={onChangeHandler} validationError={validation.name} placeholder='Name' icon={<FaUserAlt/>}/>
                            <Input type="text" name="email" onChangeHandler={onChangeHandler} validationError={validation.email} placeholder='Email' icon={<HiMail/>}/>
                            <Input type="text" name="phone" onChangeHandler={onChangeHandler} validationError={validation.phone} placeholder='Phone' icon={<AiFillPhone/>}/>
                            <Textarea type="text" name="message" onChangeHandler={onChangeHandler} validationError={validation.message} placeholder='Message' icon={<AiFillMessage/>}/>
                            <PrivacyTnc />
                            <div className="text-center">
                                <button className="btn-primary mt-3" type="submit" title="Send Message">Send Message</button>
                            </div>
                        </form>
                        </div>
                    </Col>
                    <Col md={{size:"6",order:1}} className="d-flex flex-column justify-content-center">
                        <Row className="row">
                            <Col xs="12">
                                <iframe title="Serviceable Area Mumbai" className="border-0 w-100" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241316.64332687482!2d72.74109952278411!3d19.08252232109985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1575904061086!5m2!1sen!2sin" height="450" frameBorder="0" allowFullScreen=""></iframe>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
        </>
    )
}

export default Index